import {
  Box,
  Button,
  ButtonGroup,
  Divider,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
} from '@chakra-ui/react';

import modalStyles from '../../../../DataBuilder/data-builder-modals.module.css';
import type { BaseStepsInterface } from '../../../data-enrichment/types/dataEnrichmentTypes';
import { useFileUploadStore } from '../../../file-upload/file-upload-context';
import stepperStyles from '../../../upload-modal-stepper.module.css';

interface UploadCompaniesModalProps {
  children: React.ReactNode;
  onContinue?: () => void;
  isLoadingContinue?: boolean;
  onPrevious?: () => void;
}
const UploadCompaniesModal = ({
  children,
  onContinue,
  isLoadingContinue,
  onPrevious,
}: UploadCompaniesModalProps) => {
  const activeStep = useFileUploadStore((state) => state.activeStep);
  const steps = useFileUploadStore((state) => state.steps);
  const goToPrevious = useFileUploadStore((state) => state.goToPrevious);
  return (
    <ModalContent className={modalStyles.modalContent}>
      <ModalHeader className={modalStyles.modalHeader} color="text.primary">
        Upload companies to Map
      </ModalHeader>
      <ModalCloseButton />

      <Divider className={modalStyles.divider} orientation="horizontal" />

      <ModalBody mt="14px" minHeight="360px">
        {activeStep > 0 ? (
          <Stepper
            className={stepperStyles.stepper}
            mb={6}
            colorScheme="green"
            index={activeStep}
            orientation="horizontal"
            gap="0"
            size="md"
          >
            {steps.map((step: BaseStepsInterface, index: number) => (
              <Step key={index}>
                <StepIndicator>
                  <StepStatus
                    complete={<StepIcon />}
                    incomplete={<StepNumber />}
                    active={<StepNumber />}
                  />
                </StepIndicator>

                <Box flexShrink="0">
                  <StepTitle>{step.title}</StepTitle>
                  <StepDescription>{step.description}</StepDescription>
                </Box>

                <StepSeparator />
              </Step>
            ))}
          </Stepper>
        ) : null}
        <Box overflow="auto" maxH="600px">
          {children}
        </Box>
      </ModalBody>

      <ModalFooter>
        <ButtonGroup>
          <Button
            className={modalStyles.footerBackLink}
            variant="link"
            fontSize="12px"
            colorScheme="gray"
            onClick={onPrevious || goToPrevious}
          >
            Back
          </Button>

          {onContinue ? (
            <Button
              className={modalStyles.footerPrimaryButton}
              borderRadius="4px"
              fontSize="12px"
              minWidth="100px"
              fontWeight="600"
              colorScheme="green"
              variant="solid"
              size="sm"
              onClick={onContinue}
              isLoading={isLoadingContinue}
            >
              Continue
            </Button>
          ) : null}
        </ButtonGroup>
      </ModalFooter>
    </ModalContent>
  );
};

export default UploadCompaniesModal;
